import { render, staticRenderFns } from "./AnimationComp.vue?vue&type=template&id=f3fca56c&scoped=true"
import script from "./AnimationComp.vue?vue&type=script&lang=js"
export * from "./AnimationComp.vue?vue&type=script&lang=js"
import style0 from "./AnimationComp.vue?vue&type=style&index=0&id=f3fca56c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3fca56c",
  null
  
)

export default component.exports